import AdminMidProspectVasps from './AdminMidProspectVasps'

export default AdminMidProspectVasps
